export enum STATUS_KYC {
  KO = 'KO',
  OK = 'OK',
}
